import { render, staticRenderFns } from "./ViewReport.vue?vue&type=template&id=9b4047c2"
import script from "./ViewReport.vue?vue&type=script&lang=js"
export * from "./ViewReport.vue?vue&type=script&lang=js"
import style0 from "./ViewReport.vue?vue&type=style&index=0&id=9b4047c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports